import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

function Sidebar() {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [closingSession, setClosingSession] = useState(false);

  const navigate = useNavigate();

  const user = auth.currentUser;

  const userName =
    user?.displayName || user?.email?.split("@")[0] || "Administrador";

  const userEmail = user?.email || "Sesión activa";

  async function handleLogout() {
    setClosingSession(true);

    try {
      await signOut(auth);
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    } finally {
      setClosingSession(false);
      setShowLogoutModal(false);
    }
  }

  return (
    <>
      <aside className="admin-sidebar">
        <div>
          <div className="admin-sidebar__brand">
            <img
              src="/images/IsologoWiblocolor2.png"
              alt="Logo de Wiblo"
              className="login-logo"
            />

            <div>
              <h1>Wiblo</h1>
            </div>
          </div>

          <nav className="admin-sidebar__nav">
            <NavLink to="/admin" end>
              🏠 Dashboard
            </NavLink>

            <NavLink to="/admin/users">👥 Usuarios</NavLink>

            <NavLink to="/admin/minigames">🎮 Minijuegos</NavLink>

            <NavLink to="/admin/seasons">🗓️ Temporadas</NavLink>

            <NavLink to="/admin/missions">🎯 Misiones</NavLink>

            <NavLink to="/admin/store">🛒 Tienda</NavLink>

            <NavLink to="/admin/Localization">🌐 Localización</NavLink>

            <NavLink to="/admin/storage">🗂️ Storage</NavLink>

            <NavLink to="/admin/tools">🧰 Herramientas</NavLink>
          </nav>
        </div>

        <button
          className="admin-sidebar__profile"
          type="button"
          onClick={() => setShowLogoutModal(true)}
        >
          <span className="admin-sidebar__avatar">👤</span>

          <span className="admin-sidebar__profile-info">
            <strong>{userName}</strong>
            <small>{userEmail}</small>
          </span>

          <span className="admin-sidebar__profile-arrow">⚙️</span>
        </button>
      </aside>

      {showLogoutModal && (
        <div
          className="logout-modal-backdrop"
          onClick={() => setShowLogoutModal(false)}
        >
          <section
            className="logout-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="logout-modal__icon">👤</div>

            <h2>Cerrar sesión</h2>

            <p>
              Estás conectado como <strong>{userEmail}</strong>.
              ¿Quieres cerrar tu sesión actual?
            </p>

            <div className="logout-modal__actions">
              <button
                className="small-button"
                type="button"
                onClick={() => setShowLogoutModal(false)}
                disabled={closingSession}
              >
                Cancelar
              </button>

              <button
                className="small-button small-button--danger"
                type="button"
                onClick={handleLogout}
                disabled={closingSession}
              >
                {closingSession ? "Cerrando..." : "Cerrar sesión"}
              </button>
            </div>
          </section>
        </div>
      )}
    </>
  );
}

export default Sidebar;